<template>
  <div style="width: 100%">
    <router-view id="app"/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue